import React from 'react'
import { Button, Col, Container, Row, Table } from 'react-bootstrap';
import { deleteUser, resetPassword } from '../Tools/tools';
import EditarUsuario from './EditarUsuario';
import { getAuth, sendPasswordResetEmail } from "firebase/auth";
import DeletarUsuario from './DeletarUsuario';
import '../css/table-overflow.css';

function TabelaUsuarios(props) {
    const users = props.usuarios
    
    users.sort((a, b) => {
        a.displayName = a.displayName ?? a.email ?? a.uid;
        b.displayName = b.displayName ?? b.email ?? b.uid;

        return a.displayName.localeCompare(b.displayName)
    });

    const sendPassReset = (userMail) => {
        sendPasswordResetEmail(getAuth(), userMail)
    }

    return (
        <div className='customTable'>
            <Table striped bordered hover responsive>
                <thead>
                    <tr>
                        <th>Nome</th>
                        <th>Email</th>
                        {/* <th>Email verificado</th> */}
                        <th> </th>
                    </tr>
                </thead>
                <tbody>
                    {users.map((user) => {

                        if (user.email === undefined) return <></>

                        if (user.disabled) {
                            return <></>
                        }

                        let username = user.displayName ?? ''
                    
                        return (
                            <tr key={user.uid}>
                                <td>{username}</td>
                                <td>{user.email}</td>
                                {/* <td>{user.emailVerified ? 'Sim' : 'Não'}</td> */}
                                <td >
                                    <div className='d-flex justify-content-center'>
                                        <Button
                                            variant="success"
                                            size="sm"
                                            title="Enviar email de troca de senha"
                                            onClick={() => { sendPassReset(user.email) }}
                                        >
                                            <i className="bi bi-envelope-fill"/>
                                        </Button>
                                        <EditarUsuario user={user} refreshListaUsuarios={props.refreshListaUsuarios}/>
                                        <DeletarUsuario
                                            uid={user.uid}
                                            email={user.email}
                                            handleShowToast={props.handleShowToast}
                                            refreshListaUsuarios={props.refreshListaUsuarios}
                                        />
                                    </div>
                                </td>
                            </tr>
                        )
                    })}
                </tbody>
            </Table>
        </div>
    )
}

export default TabelaUsuarios